<template>
  <Addition v-if="isAddition">
    <template #field>{{ fieldName }}</template>
    <ul v-if="change.new_value" class="labels-list">
      <li
        v-for="(label, index) in change.new_value"
        :key="`add_${label}-${index}_new`"
      >
        <p>{{ label }}</p>
      </li>
    </ul>
  </Addition>
  <Removal v-else-if="isRemoval">
    <template #field>{{ fieldName }}</template>
    <ul v-if="change.old_value" class="labels-list">
      <li
        v-for="(label, index) in change.old_value"
        :key="`remove_${label}-${index}_new`"
      >
        <p class="old-value">{{ label }}</p>
      </li>
    </ul>
  </Removal>
  <Change v-else-if="isChange">
    <template #field>{{ fieldName }}</template>
    <template #old>
      <ul v-if="change.old_value" class="labels-list">
        <li
          v-for="(label, index) in change.old_value"
          :key="`${label}-${index}_old`"
        >
          <p>{{ label }}</p>
        </li>
      </ul>
    </template>
    <template #new>
      <ul v-if="change.new_value" class="labels-list">
        <li
          v-for="(label, index) in change.new_value"
          :key="`change_${label}-${index}_new`"
        >
          <p class="new-value">{{ label }}</p>
        </li>
      </ul>
    </template>
  </Change>
</template>

<script>
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";

export default {
  name: "LabelsChange",
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  components: { Addition, Removal, Change },

  computed: {
    isAddition() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.ADDITION &&
            this.change.new_value
        : false;
    },
    isRemoval() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.REMOVAL &&
            this.change.old_value
        : false;
    },
    isChange() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.CHANGE &&
            this.change.new_value &&
            this.change.old_value
        : false;
    },
    fieldName() {
      return this.change.field.name;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  white-space: pre-wrap;
}

.labels-list {
  list-style: none;
  padding-left: 0;
}

.new-value {
  font-weight: bold;
}

.old-value {
  text-decoration: line-through;
}
</style>
